import * as React from 'react';

export type ICreateInspectionContext = {
  onSucceed: () => void;
  onCancel: () => void;
};

const defaultValues: ICreateInspectionContext = {
  onSucceed: () => {},
  onCancel: () => {},
};

export const CreateInspectionContext = React.createContext<ICreateInspectionContext>(defaultValues);

export const CreateInspectionProvider: React.FC<Partial<ICreateInspectionContext>> = ({ children, onSucceed = defaultValues.onSucceed, onCancel = defaultValues.onCancel }) => {
  return <CreateInspectionContext.Provider value={{ onSucceed, onCancel }}>{children}</CreateInspectionContext.Provider>;
};
